






export default {
	name: 'App',
	components: {},
	data() {
		return {
			loading: false,
			loadingText: this.$t('common.loading'),
		};
	},
	mounted() {
		// this.$firebase.auth().onAuthStateChanged(async user => {
		// 	try {
		// 		if (user) {
		// 			if (this.ramboxLogin || this.newUser) return (this.loading = false);
		// 			this.loading = true;
		// 			this.loadingText = 'Redirecting to your organization...';
		// 			const response = await this.$store.dispatch('authenticate', { user: user });
		// 			this.loading = false;
		// 			if (response.organizationId) this.$router.push(`/${response.organizationId}/_/dashboard`);
		// 		} else {
		// 			this.loadingText = this.$options.data.call(this).loadingText;
		// 			this.$route.meta.requiresAuth && (window.location.href = '/');
		// 		}
		// 		this.loading = false;
		// 	} catch (error) {
		// 		this.loading = false;
		// 		this.$message({
		// 			type: 'error',
		// 			message: error.message,
		// 		});
		// 	}
		// });
	},
};
